const RightArrow = ({ width = 24, height = 24, ...props }: React.SVGProps<SVGSVGElement>) => (
  <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M19.207 11.293C19.5976 11.6835 19.5976 12.3165 19.207 12.707L12.207 19.707L10.793 18.293L16.0859 13H4V11H16.0859L10.793 5.70703L12.207 4.29297L19.207 11.293Z'
      fill='black'
    />
  </svg>
);
export default RightArrow;
